import { FeatureFlagsStore } from "../store/featureFlags";

export enum PLMMigrationPhase {
    LEGACY = "LEGACY",
    PHASE_1 = "PHASE_1", // PITCH_WRITE_BOTH_READ_ACC
    PHASE_2 = "PHASE_2", // PITCH_WRITE_BOTH_READ_PLM
    PHASE_3 = "PHASE_3", // PITCH_WRITE_AND_READ_PLM
}

export function getPLMMigrationPhase(): PLMMigrationPhase {
    const featureFlags = FeatureFlagsStore.getState();

    if (featureFlags.pitchWriteAndReadPLM) return PLMMigrationPhase.PHASE_3;
    if (featureFlags.pitchWriteBothReadPLM) return PLMMigrationPhase.PHASE_2;
    if (featureFlags.pitchWriteBothReadACC) return PLMMigrationPhase.PHASE_1;
    return PLMMigrationPhase.LEGACY;
}
